import axios from 'axios';
import { toast } from 'react-toastify';
import logger from './loggerService';

axios.defaults.baseURL = process.env.REACT_APP_API_URL;
// Handling unexpected error globally
axios.interceptors.response.use(null, (error) => {
  const expectedError = error.response && error.response.status >= 400 && error.response.status <= 500;
  if (!expectedError) {
    logger.log(error);
    toast.error(`Unexpeted error occured : ${error.response.data}`, {
      hideProgressBar: true,
      autoClose: 8000,
    });
  }
  return Promise.reject(error);
});

export function setTokenHeader(jwtToken) {
  if (jwtToken) {
    axios.defaults.headers.common.Authorization = `Bearer ${jwtToken}`;
    axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
  } else {
    delete axios.defaults.headers.common.Authorization;
  }
}
// export default method of axios
export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  setTokenHeader,
};
